import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'reactflow/dist/style.css';
import { axiosInstance } from './service/ApiService';

import { LocalStorageService } from './service/LocalStorageService';
import Tap from '@tapfiliate/tapfiliate-js';

import TagManager from 'react-gtm-module';

type GTMDataLayerApiErrorEvent = {
  event: string;
  errorCode: number;
  errorMessage: string;
  errorUrl: string;
};

Tap.init('47903-66403d');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>
);

axiosInstance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401) {
      LocalStorageService.removeItem('accessToken');
    }

    // Define the error event with more details
    const errorEvent: GTMDataLayerApiErrorEvent = {
      event: 'apiError',
      errorCode: error.response.status,
      errorMessage: error.message,
      errorUrl: error.config.url,
    };

    // Push the detailed error event to the GTM data layer
    TagManager.dataLayer({
      dataLayer: [errorEvent],
    });

    return Promise.reject(error);
  },
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
